import { render } from "./Yihuo.vue?vue&type=template&id=667173c6&scoped=true"
import script from "./Yihuo.vue?vue&type=script&lang=js"
export * from "./Yihuo.vue?vue&type=script&lang=js"

import "./Yihuo.vue?vue&type=style&index=0&id=667173c6&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667173c6"]])

export default __exports__